import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';

import {
  NEW_FILTER_EXTRATOS_OFX,
  NEW_FILTER_EXTRATOS_OFX_PENDING,
  NEW_FILTER_EXTRATOS_OFX_SUCCESS,
  NEW_FILTER_EXTRATOS_OFX_FAILURE,
  findAllContaBancoCadastro,
} from '@handler';
import { formatDateDDMMYYYY, formatDateYYYYMMDD } from '@components/common/format';
import { buscarExtratosOfx } from '../../service';
import {
  CONST_ROWS_PER_PAGE_CONCILIACAO,
} from '@commons/consts';
import { CONFIG_SESSION } from '@handler/common/startSession';

const CONST_FILTER_EXTRATOS_OFX = 'CONST_FILTER_EXTRATOS_OFX';

function* sagaNewFilterExtratosOfx(action) {
  try {
    yield put({ type: NEW_FILTER_EXTRATOS_OFX_PENDING });

    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    let datas = '';
    let dataInicial = '';
    let dataFinal = '';
    var date = new Date();
    let where = '';
    let filterSaved = sessionStorage.getItem(CONST_FILTER_EXTRATOS_OFX) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_EXTRATOS_OFX)) : null;

    let newFilter = {
      contaBanco: null,
      dataInicial: '',
      dataFinal: '',
      rows: filterSaved?.rows || CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: filterSaved?.page || 0,
      where: ''
    };

    if (filterSaved === null || filterSaved === undefined) {
      // seta data do mes na primeira vez que entra na pagina
      dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
      dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

      datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
      where = '';
      const contasCadastro = yield call(findAllContaBancoCadastro, idFazenda);
      let contaBanco = null;

      if (contasCadastro !== null && contasCadastro !== undefined && contasCadastro.length >= 1) {
        contaBanco = contasCadastro[0];
      }

      newFilter = {
        ...newFilter,
        dataInicial,
        dataFinal,
        contaBanco: contaBanco,
        contasCadastro: contasCadastro,
        where: where
      };
    } else {
      // se seta filtro manual
      if (action.newFilter) {
        // Quando aplica um novo filtro, volta para a primeira página
        // mas mantém o número de registros por página selecionado pelo usuário
        newFilter.page = 0;

        // seta filtro indicado
        // typePeriodo = 0 -> periodo manual
        // typePeriodo = 1 -> hoje
        // typePeriodo = 2 -> esta semana
        // typePeriodo = 3 -> mes passado
        // typePeriodo = 4 -> este mes
        // typePeriodo = 5 -> proximo mes
        // typePeriodo = 6 -> este ano
        if (action.typePeriodo === undefined || action.typePeriodo === 0) {
          dataInicial = action.args.dataInicial;
          dataFinal = action.args.dataFinal;

          datas = formatDateDDMMYYYY(action.args.dataInicial) + '_' + formatDateDDMMYYYY(action.args.dataFinal);
        } else if (action.typePeriodo === 1) {
          dataInicial = formatDateYYYYMMDD(new Date(date));
          dataFinal = formatDateYYYYMMDD(new Date(date));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 2) {
          const primeiro = date.getDate() - date.getDay();
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), primeiro + 6));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 3) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() - 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 4) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth(), 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 5) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 1, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), date.getMonth() + 2, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        } else if (action.typePeriodo === 6) {
          dataInicial = formatDateYYYYMMDD(new Date(date.getFullYear(), 0, 1));
          dataFinal = formatDateYYYYMMDD(new Date(date.getFullYear(), 12, 0));

          datas = formatDateDDMMYYYY(dataInicial) + '_' + formatDateDDMMYYYY(dataFinal);
        }

        newFilter = {
          ...newFilter,
          ...action.args,
          dataInicial,
          dataFinal,
          where: where
        };

      } else {
        // busca filtro salvo
        datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

        newFilter = {
          ...filterSaved,
          where: where
        };
      }
    }

    // busca registros dos extratos OFX
    let list = yield call(
      buscarExtratosOfx,
      idFazenda,
      newFilter.contaBanco?.id ?? -1,
      datas,
      `&page=${newFilter.page}&size=${newFilter.rows}${where}`
    );

    sessionStorage.setItem(CONST_FILTER_EXTRATOS_OFX, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_EXTRATOS_OFX_SUCCESS,
      list: list,
      filter: newFilter
    });

  } catch (error) {
    yield put({ type: NEW_FILTER_EXTRATOS_OFX_FAILURE, error: error.message });
  }
}

export default function* watchNewFilterExtratosOfx() {
  yield takeLatest(NEW_FILTER_EXTRATOS_OFX, sagaNewFilterExtratosOfx);
}
